// src/PublicUser/components/freeCertificates/FreeCertificatesHero.jsx
import React from 'react';
import '../../css/certification/FreeCertificatesHero.css';

const FreeCertificatesHero = ({ searchQuery, setSearchQuery, stats }) => {
  return (
    <section className="ts-cert-hero">
      <div className="ts-cert-hero-inner">
        <div className="ts-cert-title-area">
          <h1>Free <span>Certifications</span></h1>
          <p>
            Unlock your potential with industry-recognized free certificates from top providers. 
            Learn data science, AI, cloud computing, and more at zero cost.
          </p>
        </div>

        <div style={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: '0.75rem', 
          alignItems: 'center', 
          justifyContent: 'space-between' 
        }}>
          <div className="ts-cert-search-bar">
            <span className="ts-cert-search-icon">🔍</span>
            <input
              type="text"
              className="ts-cert-input"
              placeholder="Search certifications..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="ts-cert-stats-strip">
            <div className="ts-cert-stat-pill">
              All: <span className="ts-cert-stat-count">{stats.total}</span>
            </div>
            <div className="ts-cert-stat-pill">
              Free: <span className="ts-cert-stat-count">{stats.free}</span>
            </div>
            <div className="ts-cert-stat-pill">
              Financial Aid: <span className="ts-cert-stat-count">{stats.withFinancialAid}</span>
            </div>
            <div className="ts-cert-stat-pill">
              Categories: <span className="ts-cert-stat-count">{stats.categories}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeCertificatesHero;